import { encodePaginatableQuery, encodeSortableQuery, PaginatableQuery, Query, SortableQuery } from '@/services/api';
import * as q from '@/services/api/request/query';

export interface AnalyticsQuery extends PaginatableQuery, SortableQuery {
  search: string;
}

export const encodeAnalyticsQuery = (query: AnalyticsQuery): Query => ({
  ...encodePaginatableQuery(query),
  search: q.string(query.search),
  ...encodeSortableQuery(query),
});
